import { GIT_REVISION } from "./_build_revision";
window.__CORONIS__VERSION = GIT_REVISION;

import $ from "jquery";
import jsfix from "jsfix";
// needed to add more js fixes to coronis
import { import_by_name } from "imports";

// always in the main js file, to speedup the loading, as always needed
import "coronis"; // eslint-disable-line no-unused-vars
import "cookielaw";
import "utils";
import settings from "settings";
import "index";
import "slider";
import "forms";
import "jquery-ui-import";

window.$ = window.jQuery = $;

window.onerror = function (desc, file, line, col, err) {
  var error = {
    description: desc,
    error: err && err.stack.split("\n"),
    navigator: navigator.appVersion,
    screen: {
      width: window.screen.width,
      height: window.screen.height,
      orientation: window.screen.orientation,
    },
  };
  $.post("/error/clientlog", { data: JSON.stringify(error) });
};

$("ajax require").each(function () {
  required = $(this)
    .text()
    .replace(/,/g, " ")
    .split(/ +/)
    .forEach(function (r) {
      // console.log("Require <%o>", r);
      import_by_name(r).then(function (a) {
        a && a.load && a.load();
      });
    });
});

jsfix.register("js-hamburger", function ($el, menu_sel) {
  $el.click(function () {
    $el.find(".open").toggle();
    $el.find(".close").toggle();
    $(menu_sel).toggle();
  });
});
jsfix.register("js-toggle-slide", function ($el, menu_sel) {
  $el.addClass("closed").removeClass("open"); // Start in closed state.
  $el.click(function () {
    $el.toggleClass("selected");
    $el.toggleClass("closed");
    $el.toggleClass("open");
    $(menu_sel).slideToggle("slow");
  });
});
jsfix.register("js-toggle", function ($el, menu_sel) {
  $el.click(function () {
    $el.toggleClass("selected");
    $(menu_sel).toggle();
  });
});

jsfix.register("js-click-on-click", function ($el, sel) {
  $el.click(function () {
    // console.log("Click", $(sel));
    $(sel).click();
  });
});
jsfix.register("js-hide-on-click", function ($el, sel) {
  $el.click(function () {
    // console.log("Click", $(sel));
    $(sel).hide();
  });
});
jsfix.register("js-show-on-click", function ($el, sel) {
  $el.click(function () {
    $(sel).show();
  });
});
jsfix.register("js-toggle-open", function ($el, sel) {
  $el.click(function () {
    $el.toggleClass("selected");
    $el.toggleClass("closed");
    $el.toggleClass("open");
  });
});

jsfix.register("js-font-size", function ($el, sel) {
  $el.find("input").change(function () {
    var val = $(this).val();
    var $sel = $(sel);
    $sel.removeClass("s m l");
    $sel.addClass(val);
  });
});
jsfix.register("js-css", function ($el, sel) {
  import("utils").then(function (utils) {
    utils.requireCSS(sel);
  });
});

import initDatepickerDefaults from "./datepicker-init";
import _ from "trans";

// Initialize datepicker defaults early so they're available for any datepicker() calls
// This ensures all datepickers start on Monday, even those created in inline scripts
// Try multiple sources for language detection
const detectedLang =
  settings.LANG || (typeof _ !== "undefined" && _.languageCode) || null;
initDatepickerDefaults({ lang: detectedLang });

jsfix.register("js-datepicker", function ($el, sel) {
  // $("body").append(
  //   $('<link href="' + STATIC_URL + '/css/jquery-ui.css" rel="stylesheet">')
  // );
  // Re-initialize to ensure defaults are set (in case jquery-ui loads after this)
  const detectedLang =
    settings.LANG || (typeof _ !== "undefined" && _.languageCode) || null;
  initDatepickerDefaults({ lang: detectedLang });

  if (sel) $el.datepicker({ defaultDate: sel });
  else $el.datepicker();
});

jsfix.register("js-flash", ($el) => {
  $el.find(".close").click(function () {
    $el.remove();
  });
  $el.delay(10000).fadeOut(function () {
    $(this).remove();
  });
});

jsfix.register("js-print", function ($el) {
  $el.click(function () {
    $("body").addClass("print");
    $('[href="#show_1000"]').click();
    setTimeout(window.print, 1000);
  });
});
jsfix.register("js-print-now", function ($el) {
  setTimeout(window.print, 1000);
});

jsfix.register("js-reload", function ($el, val) {
  if (val.endsWith("m")) {
    val = Number(val.slice(0, val.length - 1)) * 60 * 1000;
  } else {
    val = Number(val) * 1000;
  }
  console.log("Reload in %d ms", val);
  setTimeout(function () {
    window.location.pathname = window.location.pathname;
  }, val);
});

var url = window.location.pathname; // Only relative
$("a").each(function () {
  var a = $(this);
  if (a.attr("href") == url) a.addClass("selected");
});

var windowsize = $(window).width();

function checkHeader() {
  if (windowsize >= 974) {
    //change header only in desktop version
    if ($(window).scrollTop() > 150) {
      $(".header_ontop").hide();
      $(".header_onscroll, .onscroll").show();
    } else {
      $(".header_ontop").show();
      $(".header_onscroll, .onscroll").hide();
    }
  } else {
    $(".header_ontop").show();
    $(".header_onscroll").hide();
  }
}

function loadCss(css) {
  var link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = css;
  document.head.appendChild(link);
}
loadCss("/static/js/main.css");

checkHeader();

$(window).scroll(function () {
  checkHeader();
});
$(window).resize(function () {
  windowsize = $(window).width();
  checkHeader();
});
